module.exports = __webpack_public_path__ + "assets/img/img171.23f74072.png";